import React from "react";
import { Link } from "react-router-dom";
import { useFormContext } from "react-hook-form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import { ReactComponent as CenterParcs } from "../../assets/icons/CenterParcs.svg";

type ResetPasswordProps = {
  onSubmit: (data: any) => void;
  loading: boolean;
  t: any;
};

const CenterParcsResetPassword: React.FC<ResetPasswordProps> = ({
  onSubmit,
  loading,
  t,
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <div
      className="row vh-100 d-flex align-items-center justify-content-center"
      style={{ background: "#b1eda6" }}
    >
      <Container fluid>
        <Row className="justify-content-center">
          <Col xl={5} lg={6} md={7} sm={9} xs={11}>
            <div className="text-center mb-5 pb-5">
              <CenterParcs style={{ maxWidth: "450px", width: "100%" }} />
            </div>

            <div
              className="p-4 p-md-5 shadow-sm"
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.15)",
                borderRadius: "20px",
              }}
            >
              <div className="text-center mb-4">
                <h4 style={{ color: "#045e51", fontWeight: "bold" }}>
                  {t("resetPassword:title")}
                </h4>
              </div>

              <Form onSubmit={onSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label
                    className="fw-bold mb-2"
                    style={{ color: "#045e51" }}
                    htmlFor="centerparcs-reset-password"
                  >
                    {t("resetPassword:form.password.label")}
                  </Form.Label>
                  <Form.Control
                    type="password"
                    id="centerparcs-reset-password"
                    size="lg"
                    className="border-0 rounded-pill"
                    style={{
                      backgroundColor: "rgba(255, 255, 255, 0.3)",
                      border: "2px solid #045e51",
                      color: "#045e51",
                    }}
                    placeholder={t("resetPassword:form.password.placeholder")}
                    autoComplete="new-password"
                    {...register("password")}
                    isInvalid={!!errors.password}
                  />
                  <Form.Control.Feedback type="invalid">
                    {typeof errors.password?.message === "string"
                      ? errors.password.message
                      : null}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label
                    className="fw-bold mb-2"
                    style={{ color: "#045e51" }}
                    htmlFor="centerparcs-reset-confirm-password"
                  >
                    {t("resetPassword:form.confirmPassword.label")}
                  </Form.Label>
                  <Form.Control
                    type="password"
                    id="centerparcs-reset-confirm-password"
                    size="lg"
                    className="border-0 rounded-pill"
                    style={{
                      backgroundColor: "rgba(255, 255, 255, 0.3)",
                      border: "2px solid #045e51",
                      color: "#045e51",
                    }}
                    placeholder={t(
                      "resetPassword:form.confirmPassword.placeholder",
                    )}
                    autoComplete="new-password"
                    {...register("confirmPassword")}
                    isInvalid={!!errors.confirmPassword}
                  />
                  <Form.Control.Feedback type="invalid">
                    {typeof errors.confirmPassword?.message === "string"
                      ? errors.confirmPassword.message
                      : null}
                  </Form.Control.Feedback>
                </Form.Group>

                <div>
                  <Button
                    type="submit"
                    disabled={loading}
                    className="w-100 rounded-pill py-3 mb-3 border-0"
                    style={{
                      backgroundColor: "#045e51",
                      color: "#b1eda6",
                      fontSize: "16px",
                      fontWeight: "bold",
                      boxShadow: "none",
                    }}
                    onFocus={(e: React.FocusEvent<HTMLButtonElement>) => {
                      e.currentTarget.style.boxShadow =
                        "0 0 0 0.2rem rgba(4, 94, 81, 0.25)";
                      e.currentTarget.style.outline = "none";
                    }}
                    onBlur={(e: React.FocusEvent<HTMLButtonElement>) => {
                      e.currentTarget.style.boxShadow = "none";
                    }}
                    onMouseEnter={(e: React.MouseEvent<HTMLButtonElement>) => {
                      if (!loading) {
                        e.currentTarget.style.backgroundColor = "#034a3d";
                      }
                    }}
                    onMouseLeave={(e: React.MouseEvent<HTMLButtonElement>) => {
                      if (!loading) {
                        e.currentTarget.style.backgroundColor = "#045e51";
                      }
                    }}
                  >
                    {loading
                      ? t("resetPassword:button.loading")
                      : t("resetPassword:button.submit")}
                  </Button>

                  <Button
                    as={Link}
                    to="/login"
                    className="w-100 rounded-pill py-3 text-decoration-none"
                    style={{
                      backgroundColor: "transparent",
                      border: "2px solid #045e51",
                      color: "#045e51",
                      fontSize: "16px",
                      fontWeight: "bold",
                      boxShadow: "none",
                    }}
                    onFocus={(e: React.FocusEvent<HTMLButtonElement>) => {
                      e.currentTarget.style.boxShadow =
                        "0 0 0 0.2rem rgba(4, 94, 81, 0.25)";
                      e.currentTarget.style.outline = "none";
                    }}
                    onBlur={(e: React.FocusEvent<HTMLButtonElement>) => {
                      e.currentTarget.style.boxShadow = "none";
                    }}
                    onMouseEnter={(e: React.MouseEvent<HTMLButtonElement>) => {
                      e.currentTarget.style.backgroundColor =
                        "rgba(4, 94, 81, 0.1)";
                    }}
                    onMouseLeave={(e: React.MouseEvent<HTMLButtonElement>) => {
                      e.currentTarget.style.backgroundColor = "transparent";
                    }}
                  >
                    {t("common:backToLogin")}
                  </Button>
                </div>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CenterParcsResetPassword;
